import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import React__default, { forwardRef, useMemo } from 'react';
import { useComponentTheme } from '../../../theme/theme.context.esm.js';
import { PrivateImage } from '../../image/image.esm.js';
import { useCardContext } from '../card-context/card-context.esm.js';

var _excluded = ["children", "className", "mode"];
var CardImage = /*#__PURE__*/forwardRef(function CardImage(props, ref) {
  var theme = useComponentTheme('Card');
  props.children;
    var _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    _props$mode = props.mode,
    mode = _props$mode === void 0 ? 'light' : _props$mode,
    rest = _objectWithoutProperties(props, _excluded);
  var _useCardContext = useCardContext(),
    radius = _useCardContext.radius;
  var classes = useMemo(function () {
    return theme.header({
      className: className,
      radius: radius
    });
  }, [theme, className, radius]);
  return /*#__PURE__*/React__default.createElement(PrivateImage, _extends({
    anchorClassName: "csg-tw-card-image",
    ref: ref,
    className: classes,
    mode: mode
  }, rest));
});
CardImage.displayName = 'Card.Image';
var CardImage$1 = CardImage;

export { CardImage$1 as default };
//# sourceMappingURL=card-image.esm.js.map
